import Backbone from 'backbone';
import Radio from 'backbone.radio';
import _ from 'lodash';

import makeFormReadOnly from '@/util/makeFormReadOnly';
import EmptySetView from '@/views/EmptySetView';

import MaintenanceGeneralView from '../../forms/GeneralFormView/MaintenanceGeneralView/MaintenanceGeneralView';
import DesktopGeneralView from '../../forms/GeneralFormView/DesktopGeneralView/DesktopGeneralView';
import WideFormatGeneralView from '../../forms/GeneralFormView/WideFormatGeneralView/WideFormatGeneralView';
import PRTNRGeneralView from '../../forms/GeneralFormView/PRTNRGeneralView/PRTNRGeneralView';
import MFDGeneralView from '../../forms/GeneralFormView/MFDGeneralView/MFDGeneralView';
import VB0GeneralView from '../../forms/GeneralFormView/VB0GeneralView/VB0ConusGeneralView';
import RelocationGeneralView from '../../forms/GeneralFormView/RelocationGeneralView/RelocationGeneralView';

import SubmittableOrderView from '../SubmittableOrderView/SubmittableOrderView';

import tmplOrderGeneralView from './OrderGeneralView.hbs';

const OrderGeneralView = SubmittableOrderView.extend({
  template: tmplOrderGeneralView,

  className: 'order-general-view',

  ui: {
    generalQuestions: '.general-questions'
  },

  regions: {
    generalQuestions: '@ui.generalQuestions'
  },

  childViewEvents: {
    'has:errors': 'onHasErrors',
    'no:errors': 'onNoErrors'
  },

  initialize() {
    Radio.channel('order').reply('get:defaultNote', () => {
      const { hasReq, accessNotes } = this.model.get('order');
      return (hasReq === '1' && accessNotes) || '';
    });

    Radio.channel('order').reply('get:finPoc', () => {
      const { firstName, lastName, email, telephone } = this.model.get('order');
      return { firstName, lastName, email, telephone};
    });
  },

  onRender() {
    switch (this.model.get('orderDetails').orderTypeId) {
      case '1':
      case '3':
        this.showChildView(
          'generalQuestions',
          new MFDGeneralView({
            model: new Backbone.Model({
              order: this.model.get('order'),
              orderDetails: this.model.get('orderDetails'),
              isInternal: !EXTERNAL,
              isReadOnly: this.model.get('isReadOnly')
            })
          })
        );
        break;
      case '2':
      case '13':
      case '14':
      case '15':
      case '22':
      case '23':
      case '24':
      case '25':
      case '26':
        this.showChildView(
          'generalQuestions',
          new PRTNRGeneralView({
            model: new Backbone.Model({
              order: this.model.get('order'),
              orderDetails: this.model.get('orderDetails'),
              isReadOnly: this.model.get('isReadOnly'),
              isInternal: !EXTERNAL,
              isOtherCountry: this.model.get('isOtherCountry')
            })
          })
        );
        break;

      case '4':
        this.showChildView(
          'generalQuestions',
          new MaintenanceGeneralView({
            model: new Backbone.Model({
              order: this.model.get('order'),
              orderDetails: this.model.get('orderDetails'),
              isReadOnly: this.model.get('isReadOnly'),
              isInternal: !EXTERNAL
            })
          })
        );
        break;

      case '17':
        this.showChildView(
          'generalQuestions',
          new WideFormatGeneralView({
            model: new Backbone.Model({
              order: this.model.get('order'),
              orderDetails: this.model.get('orderDetails'),
              isReadOnly: this.model.get('isReadOnly'),
              isInternal: !EXTERNAL
            })
          })
        );
        break;

      case '6':
      case '10':
      case '11':
        this.showChildView(
          'generalQuestions',
          new DesktopGeneralView({
            model: new Backbone.Model({
              order: this.model.get('order'),
              orderDetails: this.model.get('orderDetails'),
              isReadOnly: this.model.get('isReadOnly'),
              isInternal: !EXTERNAL
            })
          })
        );
        break;

      case '12':
        this.showChildView(
          'generalQuestions',
          new RelocationGeneralView({
            model: new Backbone.Model({
              order: this.model.get('order'),
              orderDetails: this.model.get('orderDetails'),
              isReadOnly: this.model.get('isReadOnly'),
              isInternal: !EXTERNAL
            })
          })
        );
        break;

      case '16':
      case '18':
      case '20':
      case '21':
        this.showChildView(
          'generalQuestions',
          new VB0GeneralView({
            model: new Backbone.Model({
              order: this.model.get('order'),
              orderDetails: this.model.get('orderDetails'),
              isReadOnly: this.model.get('isReadOnly'),
              isInternal: !EXTERNAL
            })
          })
        );
        break;

      default:
        this.showChildView(
          'generalQuestions',
          new EmptySetView({
            emptyText: 'General data not available for migrated orders.'
          })
        );
        break;
    }

    if (this.model.get('isReadOnly')) {
      makeFormReadOnly(this.$el);
    }
  },

  onHasErrors() {
    this.trigger('has:errors');
  },

  onNoErrors() {
    this.trigger('no:errors');
  },

  async onSave() {
    const view = this.getChildView('generalQuestions');
    await view.onSave();
  },

  async validate() {
    if (_.isFunction(this.getChildView('generalQuestions').validate)) {
      const isValid = await this.getChildView('generalQuestions').validate();
      if (!isValid) this.showSubmissionError(this.model.get('orderDetails')?.orderId);
      return isValid !== false;
    }
    return true;
  }
});

export default OrderGeneralView;
